import { render, staticRenderFns } from "./ParentsList.vue?vue&type=template&id=fdafda0c&scoped=true&"
import script from "./ParentsList.vue?vue&type=script&lang=js&"
export * from "./ParentsList.vue?vue&type=script&lang=js&"
import style0 from "./ParentsList.vue?vue&type=style&index=0&id=fdafda0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdafda0c",
  null
  
)

export default component.exports